import { IFeature, IFeatureGroup } from '../definitions/Classification'
import { IContractSchema } from '../definitions/ContractSchema'
import { IFormField } from '../definitions/FormField'
import ContractFormHelper from '../components/editor/form_builder/FormHelper'
import editorOptionsRegistry from './EditorOptionsRegistry'
import { ISystemConfigsCollection } from '../definitions/Common'

class GroupsManagerClass {
    generateShape = (field: IFormField): string => {
        if (field.type === 'object') {
            return ` {${field.objectFields?.map(x => this.generateShape(x)).join(', ')}}`
        } else if (field.type === 'list') {
            return ` [${field.childFields?.map(x => this.generateShape(x)).join(', ')}] `
        } else {
            return ` ${field.label || field.key}: ${field.type} `
        }
    }

    transformField = (field: IFormField): IFeature[] => {
        const features: IFeature[] = []

        features.push({
            name: field.key,
            description: field.description ?? field.label ?? field.key,
            permissibleValues: [],
            examples: [],
            shape: field.type === 'list' ? this.generateShape(field) : undefined
        })

        if (field.type === 'object' && field.objectFields) {
            field.objectFields.forEach(child => {
                this.transformField(child).forEach(f => features.push(f))
            })
        }

        return features
    }

    getFeatureGroups = (fields: IFormField[], size: number): IFeatureGroup[] => {
        const groups: IFeatureGroup[] = []
        const normalFeatures: IFeature[] = []

        fields.forEach(field => {
            if (field.type === 'list') {
                const listFeatures: IFeature[] = []
                field.childFields?.forEach(child => {
                    this.transformField(child).forEach(f => listFeatures.push(f))
                })

                groups.push({
                    features: listFeatures,
                    isList: true,
                    nameList: field.key
                })
            } else {
                this.transformField(field).forEach(f => normalFeatures.push(f))
            }
        })

        for (let i = 0; i < normalFeatures.length; i += size) {
            groups.push({ features: normalFeatures.slice(i, i + size) })
        }

        return groups
    }

    transformSchemaToFeatureGroups = (schema: IContractSchema, systemConfigsCollection: ISystemConfigsCollection[]): IFeatureGroup[] => {
        editorOptionsRegistry.setOptions(systemConfigsCollection)

        const topLevelFields = schema.steps.flatMap(s => s.fields)

        const rawGroups = this.getFeatureGroups(topLevelFields, 15)

        return rawGroups.map(group => ({
            ...group,
            features: group.features.map(f => {
                const allFields = schema.steps.flatMap(step => ContractFormHelper.flatSteps(step))
                const normalize = (key: string) =>
                    key.trim().toLowerCase().replace(/\.$/, '')

                const field = allFields.find(field =>
                    normalize(field.key) === normalize(f.name)
                )

                const options = field ? editorOptionsRegistry.getOptionsForField(field) : []

                return {
                    ...f,
                    permissibleValues: options
                        .map(o => o.name)
                        .filter(Boolean)
                        .sort()
                }
            })
        }))
    }
}

const GroupsManager = new GroupsManagerClass()
export default GroupsManager
